import React from 'react'
import { Segment } from 'semantic-ui-react'

import { Loader } from 'shared/components/Loader'

import './styles.css'

export interface ContainerShellProps {
  isLoading?: boolean
  /** Render a <ContainerShellIntro/> here when the page has a help-link / sub-heading row. */
  intro?: React.ReactNode
  children: React.ReactNode
}

export default function ContainerShell({
  isLoading = false,
  intro,
  children,
}: ContainerShellProps) {
  return (
    <Segment className="admin-section">
      {intro}
      {isLoading ? (
        <div className="container-shell__loader">
          <Loader />
        </div>
      ) : (
        children
      )}
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/ContainerShell/index.tsx